import {MatDialogRef} from '@angular/material/dialog';
import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ENTER} from '@angular/cdk/keycodes';

@Component({
  template: `
    <app-dialog>
      <app-dialog-title>
        <language
          key="CtrlAttributeFlowConstantDialogTitle"
          defaultValue="Add/Edit Constant"
        ></language>
      </app-dialog-title>

      <button
        app-dialog-header-button
        mat-icon-button
        (click)="dialogRef.close(value)"
        class="mat-icon-button-primary-color"
      >
        <mat-icon>check</mat-icon>
      </button>
      <button
        app-dialog-header-button
        mat-icon-button
        (click)="dialogRef.close(null)"
        class="mat-icon-button-error-color"
      >
        <mat-icon>undo</mat-icon>
      </button>

      <div mat-dialog-content>
        <mat-form-field>
          <input matInput [type]="inputType" [(ngModel)]="value" (keydown)="keyDown($event)" />
          <mat-label>
            <language
              key="CtrlAttributeFlowConstantDialogValuePlaceholder"
              defaultValue="Value of the constant"
            ></language>
          </mat-label>
        </mat-form-field>
      </div>
    </app-dialog>
  `,
  styles: [
    'app-dialog { width: var(--mat-dialog-container-max-width); } mat-form-field { width: 100%; }',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AttributeFlowConstantDialog {
  public type: 'String' | 'Number';
  public value: string = '';

  constructor(public dialogRef: MatDialogRef<AttributeFlowConstantDialog>) {}

  get inputType(): string {
    return this.type === 'Number' ? 'number' : 'text';
  }

  keyDown(event): void {
    if (event.keyCode === ENTER) {
      this.dialogRef.close(this.value);
    }
  }
}
